// a tag should be be dressed up to look like a custom button, we should use a Button instead
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ArrowDropDown } from '@mui/icons-material';
import { Link, Typography } from '@mui/material';
import React from 'react';
import styles from '../styles';

const NavTitle = ({ nav, handleClick, handleClose }) => (
  <Link
    underline='hover'
    // href={nav.link.link}
    sx={styles.mainNavStyle.mainNavs}
    id={nav?.title}
    aria-label={nav?.Link?.ariaLabel}
    href=''
    // tabIndex={0}
    onClick={e => handleClick(e, nav)}
    onKeyDown={e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick(e, nav);
      }
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          handleClose();
        }
      }
    }}
  >
    <Typography sx={styles.navTitle}>{nav?.title}</Typography>

    <ArrowDropDown className='dropdownIcon' />
  </Link>
);

export default NavTitle;
